import { render } from "./SharedSamplesView.vue?vue&type=template&id=833148a6&scoped=true&ts=true"
import script from "./SharedSamplesView.vue?vue&type=script&lang=ts"
export * from "./SharedSamplesView.vue?vue&type=script&lang=ts"

import "./SharedSamplesView.vue?vue&type=style&index=0&id=833148a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833148a6"]])

export default __exports__